import { React, useEffect, useState } from "react";

import { DropDown } from "../../Components/Dropdown/index";
import { useDispatch, useSelector } from "react-redux";

import { AssetsThunks } from "../../Thunks/AssetsThunk";
import { BlockchainsThunk } from "../../Thunks/BlockchainsThunk";
import { PlatformsThunk } from "../../Thunks/PlatformsThunks";
import { CreateLightDefiThunk } from "../../Thunks/CreateLightDefiThunk";

import { SET_LIGHTDEFI_SUCCESS_FALSE } from "../../Reducer/CreateLightDefiReducer";
import { SET_BLOCKCHATIN_DATA } from "../../Reducer/BlockchainsReducer";
import { SET_PLATFORM_DATA } from "../../Reducer/PlatformsReducer";

export function AddLightDefiModal({ modalClose, title }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();

  const [dropDownError, setDropDownError] = useState();

  const [assetId, setAssetId] = useState([]);
  const [blockchainId, setBlockchainId] = useState([]);
  const [platformId, setPlatformId] = useState([]);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [assetsDefaultValue, setassetsDefaultValue] = useState(null);
  const [assetsValue, setAssetsValue] = useState(null);
  const [platformDefaultValue, setplatformDefaultValue] = useState(null);
  const [platformValue, setPlatformValue] = useState(null);

  const [blockchainsmDefaultValue, setBlockchainsmDefaultValue] =
    useState(null);
  const [blockchainsValue, setBlockchainsValue] = useState(null);

  const [openSave, setOpenSave] = useState(true);

  const [allBlockchain, setAllBlockchain] = useState(false);
  const [allPlatform, setAllPlatform] = useState(false);

  const assetsResult = useSelector((state) => {
    return state.assets.assetsResult;
  });

  const blockchainsResult = useSelector((state) => {
    return state.blockchains.blockchainsResult;
  });

  const platformResult = useSelector((state) => {
    return state.platforms.plarformsresult;
  });

  const createLightDefiSuccess = useSelector((state) => {
    return state.creteLightDefiReduicer.create_lightdefi_success;
  });

  const createLightDefiError = useSelector((state) => {
    return state.creteLightDefiReduicer.create_lightdefi_error;
  });

  useEffect(() => {}, [windowWidth]);

  useEffect(() => {
    !assetsResult?.length && dispatch(AssetsThunks());
  }, []);

  useEffect(() => {
    if (createLightDefiSuccess) {
      // dispatch(ApiGetAssets());
      dispatch({
        type: SET_BLOCKCHATIN_DATA,
        payload: {
          result: [],
        },
      });
      dispatch({
        type: SET_PLATFORM_DATA,
        payload: {
          result: [],
        },
      });
      setAssetsValue(null);
      setassetsDefaultValue(null);
      setAssetId(null);
      setplatformDefaultValue(null);
      setPlatformValue(null);
      setBlockchainsmDefaultValue(null);
      setBlockchainsValue(null);
      dispatch({ type: SET_LIGHTDEFI_SUCCESS_FALSE });
      setDropDownError(null);
      setAllBlockchain(false);
      setAllPlatform(false);
    }
  }, [createLightDefiSuccess]);

  const assetsHandleChange = (selectedOption) => {
    setDropDownError(null);
    dispatch({
      type: SET_BLOCKCHATIN_DATA,
      payload: {
        result: [],
      },
    });
    dispatch({
      type: SET_PLATFORM_DATA,
      payload: {
        result: [],
      },
    });
    if (!selectedOption) {
      return;
    }
    const name = selectedOption.label;
    const id = selectedOption.value;
    setassetsDefaultValue(selectedOption.default);
    setAssetsValue(selectedOption.assetsValue);
    setAllBlockchain(true);
    if (name === "All Assets") {
      setAssetId(id);
      dispatch(BlockchainsThunk());
    } else {
      setAssetId([id]);
      dispatch(BlockchainsThunk(id));
    }
  };

  const blockchainsHandleChange = (selectedOption) => {
    setDropDownError(null);
    dispatch({
      type: SET_PLATFORM_DATA,
      payload: {
        result: [],
      },
    });
    if (!selectedOption) {
      setBlockchainsmDefaultValue(null);
      return;
    }
    const name = selectedOption.label;
    const id = selectedOption.value;
    setBlockchainsmDefaultValue(selectedOption.default);
    setBlockchainsValue(selectedOption.blockChainValue);
    setAllPlatform(true);
    if (name === "All Blockchains") {
      setBlockchainId(id);
      dispatch(AssetsThunks());
      dispatch(PlatformsThunk(assetId?.length === 1 ? assetId[0] : null));
    } else {
      setBlockchainId([id]);
      dispatch(AssetsThunks(id));
      dispatch(PlatformsThunk(assetId?.length === 1 ? assetId[0] : null, name));
    }
  };

  const platformHandleChange = (selectedOption) => {
    setDropDownError(null);
    if (!selectedOption) {
      setShowSaveBtn(false);
      setplatformDefaultValue(null);
      return;
    }
    const name = selectedOption.label;
    const id = selectedOption.value;
    setShowSaveBtn(true);
    setplatformDefaultValue(selectedOption.default);
    setPlatformValue(selectedOption.platformvalue);
    if (name === "All Platforms") {
      dispatch(
        BlockchainsThunk(assetId?.length === 1 ? assetId[0] : null, null)
      );
      dispatch(
        AssetsThunks(blockchainId?.length === 1 ? blockchainId[0] : null)
      ); //av
      setPlatformId(id);
    } else {
      dispatch(BlockchainsThunk(assetId?.length === 1 ? assetId[0] : null, id));
      dispatch(
        AssetsThunks(blockchainId?.length === 1 ? blockchainId[0] : null, id)
      ); //av
      setPlatformId([id]);
    }
  };

  const createLightDefi = () => {
    if (assetId && blockchainId && platformId) {
      dispatch(CreateLightDefiThunk(assetId, blockchainId, platformId));
    }
  };

  const renderColorClassName = (risk) => {
    if (risk <= 100 && risk >= 80) {
      return {
        className: "card__product__number card__product__green",
      };
    } else if (risk < 80 && risk >= 60) {
      return {
        className: "card__product__number card__product__yellow",
      };
    } else if (risk < 60) {
      return {
        className: "card__product__number card__product__red",
      };
    } else if (risk === null || 0) {
      return {
        className: "card__product__number card__product__white",
      };
    }
  };

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_LIGHTDEFI_SUCCESS_FALSE,
      });
    };
  }, []);

  useEffect(() => {
    if (createLightDefiError) {
      setDropDownError(createLightDefiError);
    }
  }, [createLightDefiError]);

  const asset = Math.round(assetsValue ? assetsValue : assetsDefaultValue);
  const blockchain = Math.round(
    blockchainsValue ? blockchainsValue : blockchainsmDefaultValue
  );
  const pllatform = Math.round(
    platformValue ? platformValue : platformDefaultValue
  );

  return (
    <div
      className={
        "card  new__defi empty defi" +
        " " +
        (openSave
          ? "card  new__defi empty defi"
          : "card new new__defi empty defi")
      }
    >
      <div className="card__header">
        <div className="row">
          <h2 className="card__title">New Product</h2>
          <div
            className="close__card__content"
            onClick={() => {
              modalClose(false);
              dispatch({
                type: SET_BLOCKCHATIN_DATA,
                payload: {
                  result: [],
                },
              });
              dispatch({
                type: SET_PLATFORM_DATA,
                payload: {
                  result: [],
                },
              });
            }}
          >
            <span className="card__close">
              <span></span>
              <span></span>
            </span>
          </div>
        </div>
      </div>
      {dropDownError ? (
        <div className="card__price card__wallet__content">
          <div className="">
            <div
              className="card__wallet__rates"
              style={{ marginLeft: "10px", color: "#be6161", fontSize: "12px" }}
            >
              {dropDownError}
            </div>
          </div>
        </div>
      ) : (
        <div className="card__price card__wallet__content">
          <div className="">
            <div className="card__wallet__rates" style={{ marginLeft: "10px" }}>
              Staked amount
            </div>
          </div>
        </div>
      )}

      <div className="card__product__wrapper">
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            <DropDown
              onChange={assetsHandleChange}
              options={assetsResult}
              placeholder="Choose Asset"
              allassets={true}
              title={title}
            >
              {assetsValue || assetsDefaultValue ? (
                <div className={renderColorClassName(Number(asset))?.className}>
                  {asset}
                </div>
              ) : (
                <div className="card__product__number"> -</div>
              )}
            </DropDown>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            <DropDown
              onChange={blockchainsHandleChange}
              options={blockchainsResult}
              placeholder="Choose Blockchain"
              allblockchains={allBlockchain}
              title={title}
            >
              {blockchainsValue || blockchainsmDefaultValue ? (
                <div
                  className={
                    renderColorClassName(Number(blockchain))?.className
                  }
                >
                  {blockchain}
                </div>
              ) : (
                <div className="card__product__number"> -</div>
              )}
            </DropDown>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            <DropDown
              onChange={platformHandleChange}
              options={platformResult}
              placeholder="Choose Platform"
              allPlatform={allPlatform}
              title={title}
            >
              {platformValue || platformDefaultValue ? (
                <div
                  className={renderColorClassName(Number(pllatform))?.className}
                >
                  {pllatform}
                </div>
              ) : (
                <div className="card__product__number empty"> -</div>
              )}
            </DropDown>
          </div>
        </div>
      </div>

      <div
        className={
          "card__product__stake__block" +
          " " +
          (title === "LightDefi"
            ? "card__product__stake__block__light_defi"
            : "card__product__stake__block")
        }
      >
        <button className="card__product__stake">Stake</button>
        <button className="card__product__unstacked">Unstake</button>
      </div>

      <div className="card__risk" style={{ marginTop: "-17px" }}>
        <h3 className="card__risk__title">Create Product</h3>
        <div className="card__risk__alert active">
          <p className="card__risk__alert__title">Alert</p>
          <p className="card__risk__alert__number">0</p>
        </div>
        <div className="card__risk__chart">
          <div className="card__risk__chart__min">
            <p className="card__risk__chart__number">0</p>
            <p className="card__risk__chart__number__of">of 100</p>
          </div>
        </div>
        <div className="card__risk__info">
          <i className="icon-info-icon"></i>
        </div>
        <div className="card__risk__range active">
          <div className="card__risk__range__bg"></div>
          <div className="card__risk__range__btn">
            <div className="card__risk__range__btn__min"></div>
          </div>
        </div>
      </div>
      <div className="unstacking">
        Auto Unstacking
        <span>30</span>
      </div>
      <div
        className={
          "add__wallet new" +
          " " +
          (openSave ? "add__wallet save" : "add__wallet new")
        }
        style={{ top: "184px" }}
      >
        <div className="add__wallet__btn__bg">
          <div
            className="plus__wrapper"
            onClick={() => {
              setOpenSave(true);
            }}
          >
            <span></span>
            <span></span>
          </div>
          <button
            className={
              "save__text" +
              " " +
              (!showSaveBtn ? "btn_disabled" : "save__text")
            }
            onClick={createLightDefi}
            disabled={!showSaveBtn}
          >
            Save
          </button>
        </div>
      </div>
      <div className="new__layer"></div>
    </div>
  );
}
